const initialState = () => {
  return {
    cartTotals: {},
    cartItems: {},
    totalsAvailable: false,
  };
};

const getters = {
  cartItems: (state) => state.cartItems,
  cartTotals: (state) => state.cartTotals,
  totalsAvailable: (state) => state.totalsAvailable,
};

const mutations = {
  SET_CART_TOTALS(state, payload) {
    state.cartTotals = payload;
  },
  SET_CART_ITEMS(state, payload) {
    state.cartItems = payload;
  },
  SET_TOTALS_AVAILABLE(state, payload) {
    state.totalsAvailable = payload;
  },
};

const actions = {
  async fetchCartTotals({ commit, state }) {
    const hasExistingTotals = Object.keys(state.cartTotals || {}).length > 0;

    try {
      // Only hide totals when there is nothing to show yet.
      if (!hasExistingTotals) {
        commit('SET_TOTALS_AVAILABLE', false);
      }

      const { data } = await this.$solarClient.get('/api/checkout/totals');
      const totals = data || {};

      commit('SET_CART_TOTALS', totals);
      commit('SET_CART_ITEMS', Array.isArray(totals['items']) ? totals['items'] : []);
      commit('SET_TOTALS_AVAILABLE', true);
    } catch (err) {
      // Keep previously loaded totals visible; only hide when there are none.
      commit('SET_TOTALS_AVAILABLE', hasExistingTotals);
    } finally {
      window.dispatchEvent(new CustomEvent('CheckoutAddedProductToCartCount'));
    }
  },
};

const state = initialState();

const CheckoutTotals = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default CheckoutTotals;
